// src/components/base/StateWrapper/StateWrapper.tsx
import { FunctionalComponent, ComponentChildren } from 'preact';
import { PagePadding } from '../../widget/Pages/Pages';
import { StateMessage } from '../StateMessage/StateMessage';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import { EmptyState } from '../EmptyState/EmptyState';

interface StateWrapperProps {
  loading?: boolean;
  error?: Error | null;
  isEmpty?: boolean;
  renderLoading?: () => ComponentChildren;
  renderError?: (error: Error) => ComponentChildren;
  renderEmpty?: () => ComponentChildren;
  Wrapper?: FunctionalComponent<{ children: ComponentChildren }>;
  children?: ComponentChildren;
}

export const StateWrapper: FunctionalComponent<StateWrapperProps> = ({
  loading = false,
  error = null,
  isEmpty = false,
  renderLoading,
  renderError,
  renderEmpty,
  Wrapper = ({ children }) => <PagePadding>{children}</PagePadding>,
  children,
}) => {
  if (loading) {
    const content = renderLoading ? renderLoading() : <LoadingSpinner />;
    return <Wrapper>{content}</Wrapper>;
  }

  if (error) {
    const content = renderError ? (
      renderError(error)
    ) : (
      <StateMessage
        state="error"
        title="Something went wrong"
        message={error.message}
      />
    );

    return <Wrapper>{content}</Wrapper>;
  }

  if (isEmpty) {
    const content = renderEmpty ? (
      renderEmpty()
    ) : (
      <EmptyState title="No results" message="Nothing to show." />
    );

    return <Wrapper>{content}</Wrapper>;
  }

  return <>{children}</>;
};
